<template>
    <main-layout>
        <template slot="body">
            <section>
                <div class="text-center" :class="{'d-none': dataReady}"><i class="zmdi zmdi-refresh zmdi-hc-fw rotating text-gray home-loader"></i></div>
                <div :class="{'d-none': !dataReady}">
                    <div class="message" v-html="settings.intoduction_message"></div>
                    <main-form :mainFields="mainFields" :title="$t('LBL_PERSONNEL_CONSENTS_DATA')"></main-form>
                    <div class="user-actions">
                        <button class="btn btn-primary btn--icon-text text-uppercase" @click="exportData"><i class="zmdi" :class="{ 'zmdi-download': !exportLoader, 'zmdi-refresh zmdi-hc-fw rotating': exportLoader}"></i> {{ $t('LBL_EXPORT') }}</button>
                        <button class="btn btn-danger btn--icon-text text-uppercase" @click="forgetMe"><i class="zmdi" :class="{ 'zmdi-delete': !forgetMeLoader, 'zmdi-refresh zmdi-hc-fw rotating': forgetMeLoader}"></i> {{ $t('LBL_FORGET_ME') }}</button>
                    </div>
                    <div class="message" v-html="settings.conclusion_portal_message"></div>
                </div>
            </section>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from '@/layout/Main'
    import MainForm from '@/components/MainForm'
    import swal from 'sweetalert2'

    export default {
        data() {
            return {
                mainFields: [],
                settings: [],
                exportLoader: false,
                forgetMeLoader: false,
                dataReady: false
            }
        },

        components: {
            'main-layout': MainLayout,
            'main-form': MainForm,
        },

        methods: {
            async exportData() {
                // Prevents duplicate api call
                if(this.exportLoader){
                    return;
                }

                this.exportLoader = true
                var response = await Api.export()
                this.exportLoader = false

                if(response.success){
                    AppHelper.notify(this.$t('LBL_EXPORT_DONE'), 'info')
                }else{
                    AppHelper.notify('Error occurred', 'warning')
                }
            },

            async forgetMe() {
                // Prevents duplicate api call
                if(this.forgetMeLoader){
                    return;
                }

                this.forgetMeLoader = true
                var data = await this.showForgetMeConfirmationAlert()

                if(data.dismiss != 'cancel'){
                    await Api.forgetMe()
                    await Api.logout()
                    this.$router.push({name: 'Login'})
                }
                this.forgetMeLoader = false
            },

            async showForgetMeConfirmationAlert() {
                return await swal({
                    title: this.$t('LBL_ARE_YOU_SURE'),
                    text: this.$t('LBL_FORGET_ME_TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger',
                    confirmButtonText: this.$t('LBL_FORGET_ME_CONFIRM'),
                    cancelButtonClass: 'btn btn-secondary',
                    cancelButtonText: this.$t('LBL_CANCEL')
                })
            },
        },


        async beforeCreate(){
            // Retrieves home page structure data
            var data = await Api.fetchStructure();
            if(!data.result){
                return;
            }

            var blocks = data.result.blocks;
            var fields = [];

            for(var i in blocks){
                var block = blocks[i];
                if(!AppHelper.empty(block.fields)){
                    fields = fields.concat(block.fields);
                }
            }

            this.mainFields = fields
            this.settings = data.result.settings

            this.$store.commit('setUserInfo', data.result.user_info)
            this.$store.commit('setCompanyInfo', data.result.company_info)

            this.dataReady = true
        }
    }
</script>

<style lang="scss" scoped>
    .user-actions {
        margin-bottom: 3rem;
    }

    .main-title {
        margin-bottom: 3rem;
    }

    .message {
        margin: 2rem 0;
    }

    .home-loader {
        font-size: 4rem;
        margin-top: 3rem;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue